import { Component, ViewContainerRef } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { WithDrawalsViewModel } from '../../models/Withdrawals/withdrawals-view';
import { WithdrawalsViews } from '../../models/Withdrawals/withdrawals-view.models';
import { Customer } from '../../models/customer/customer-model';
import { WithdrawalsPurchaseOrder } from "../../models/Withdrawals/withdrawals-purchase-order.models";
import { AdminOrderDetail } from "../../models/PurchaseOrder/create-purchase-order.model";
import { WithdrawlsService } from '../../services/withdrawls/withdrawls.service';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { CustomerService } from '../../services/customer/customer.service';
import { Product } from '../../models/products/product.model';
import { ProductService } from '../../services/product/product.service';
import { OrderService } from '../../services/order/order.service';
import { EnumDropDown } from '../../models/shared/enum-dropdown';
@Component({
  selector: 'app-withdrawal-details',
  templateUrl: './withdrawal-details.component.html',
  styleUrls: ['./withdrawal-details.component.scss']
})
/** withdrawal-details component*/
export class WithdrawalDetailsComponent {
  /** withdrawal-details ctor */
  public ModelData: WithdrawalsViews;
  public customers: Customer[];
  public products: Product[];
  public ProductType: string;
  public productidDistinct: number[];
  //Filter items from grid
  filteredItems: any[];
  public rowsOnPage: number;
  public detailID: number;
  public selectID: number;
  public withDrawlsStatuses: EnumDropDown[];
  public arrRowsPerPage: number[];
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  /** withdrawal-request ctor */
  constructor(private readonly orderService: OrderService, private readonly productService: ProductService, private readonly WithdrawlService: WithdrawlsService, private readonly activatedRoute: ActivatedRoute, private readonly CustomerService: CustomerService, private readonly utilitiesService: UtilitiesService,
    public toastr: ToastsManager, vcr: ViewContainerRef, private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.ModelData = new WithdrawalsViews();
    this.ModelData.customer = new Customer();
    this.ModelData.withdrawalRequest = new WithDrawalsViewModel();
    this.ProductType = "Recent";
    this.ModelData.purchaseOrdersDetails = [];
    this.ModelData.withdrawalsPurchaseOrders = [];
    this.toastr.setRootViewContainerRef(vcr);
    this.activatedRoute.params.subscribe((params: Params) => {
      this.detailID = params['id'];
      this.getWithdrawalDetail(this.detailID);
    });
    this.getwithdrawlsStatuses();

    this.rolePermissionService.GetRolePermissions("WithdrawalRequest").subscribe(
      data => {
        if (data != null) {
          //to copy here
          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;

          this.isEditAllowed = true;
          this.customers = [];

          this.GetRowsPerPageList();
          this.toastr.setRootViewContainerRef(vcr);
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  valueChanged(value: any) {
    this.orderService.UpdateWithDrawls(this.detailID,value).subscribe(
      data=>{
          if(data)
          {
            this.toastr.success("Status has been changed.","Success");
          }
          else{
            this.toastr.error("Status has not been changed.","Error");
          }
          this.router.navigate(["withdrawals"])
      }
    )
  }
  getwithdrawlsStatuses() {
    this.orderService.GetwithDrawlStatuses().subscribe(data => {
      this.withDrawlsStatuses = data;
    });
  }
  getWithdrawalDetail(id: number) {
    this.WithdrawlService.GetWithdrawalDetails(id).subscribe(
      data => {
        this.ModelData = data; 
        this.getProdducts(this.ProductType);
      }
    )
  }
  getCustomers() {
    this.CustomerService.getCustomer().subscribe(
      data => {
        this.customers = data;
      }
    )
  }
  getProdducts(type: string) {
    this.ProductType = type;
    this.products = [];
    this.productidDistinct = [];
    for (var i = 0; i < this.ModelData.purchaseOrdersDetails.length; i++) {
      if (this.productidDistinct.filter(d => d == this.ModelData.purchaseOrdersDetails[i].productID).length == 0) {
        this.productidDistinct.push(this.ModelData.purchaseOrdersDetails[i].productID);
      }
    }
    for (var i = 0; i < this.productidDistinct.length; i++) {
      this.productService.GetProductById(this.productidDistinct[i]).subscribe(
        data => {
          this.products.push(data);
        });
    }
  }
  ifProductExist(productID: number) {
    return (this.products.find(i => i.productID == productID) == undefined);
  }
  isCustomerNull(id: number) {
    return (this.customers.filter(i => i.customerID == id).length == 0);
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
}



// WEBPACK FOOTER //
// ./src/app/finance-management/withdrawal-details/withdrawal-details.component.ts